import { render, staticRenderFns } from "./DataAiaole.vue?vue&type=template&id=9b425e54&scoped=true&"
import script from "./DataAiaole.vue?vue&type=script&lang=js&"
export * from "./DataAiaole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b425e54",
  null
  
)

export default component.exports